import moment from 'moment'
import { prettyUrlParam } from '../../../helpers'

const toTable = (tenant) => {
  return {
    id: tenant.id,
    name: tenant.name,
    enable_bioreq: tenant.enable_bioreq,
    groups: tenant.groups.length,
    members: tenant.members.length,
    modules: tenant.modules.length,
    created: moment(tenant.created_at).unix()
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(toTable)
    }
  },

  byPrettyUrlName (state, getters) {
    return (prettyName) => {
      return getters.set.find((tenant) => {
        return prettyUrlParam(tenant.name) === prettyName
      })
    }
  },

  unsavedChanges (state) {
    const current = state.current
    const formFields = state.forms.update.fields

    if (!current) {
      return false
    }

    return formFields.name && current.name !== formFields.name
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/tenants/getters.js